import { useLocation } from 'react-router';

/**
 * Хук для определения, находится ли пользователь на странице опроса
 * Работает только с анализом URL, без обращения к Redux store
 *
 * @returns true, если пользователь на странице опроса
 */
export const useIsQuizRoute = (): boolean => {
  const location = useLocation();

  // Проверяем, что мы на странице опроса (создание или редактирование)
  const quizPathMatch = location.pathname.match(/\/quiz\/(.+)$/);

  if (!quizPathMatch) {
    return false;
  }

  const afterQuiz = quizPathMatch[1];

  // Проверяем, что ID (не пустая строка и не содержит слешей)
  return afterQuiz.length > 0 && !afterQuiz.includes('/');
};
